import { type FC, memo, useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useCampaignType } from '../../../store/campaignsStore';
import { useCampaignTypeContext } from '../../../store/context/CampaignTypeContext';
import { getTimerBackgroundUrl } from '../../../utils/campaignHelpers';
import CountdownTimer from '../CountdownTimer/CountdownTimer';

import styles from './StartsIn.module.css';

const StartsIn: FC = () => {
  const { t } = useTranslation();
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const contextType = useCampaignTypeContext();
  const storeCampaignType = useCampaignType();
  const campaignType = contextType ?? storeCampaignType;

  const startsInBgImage = useMemo(
    () => getTimerBackgroundUrl(campaignType),
    [campaignType],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setShowMoreInfo((prev) => !prev);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`${styles.startsIn} ${showMoreInfo ? styles.showMoreInfo : ''}`}
      style={{ backgroundImage: startsInBgImage }}
    >
      <div className={styles.slideWrapper}>
        <div className={styles.primaryContent}>
          <CountdownTimer campaignId="panel">
            {({ label, valueRef, direction, initialValue, lessThanHour }) => (
              <>
                <span>{label}:</span>
                <span data-timer={direction} data-less-than-hour={lessThanHour !== undefined ? String(lessThanHour) : undefined} ref={valueRef}>{initialValue}</span>
              </>
            )}
          </CountdownTimer>
        </div>
        <div className={styles.moreInfo}>
          <span>{t('campaigns.more_info', 'More info')}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(StartsIn);
